import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    if (!document.referrer == "") {
      this.element.style.display = 'flex'
    }
  }

  goBack(e) {
    e.preventDefault()
    window.history.back()
  }
}